import firebase, { db } from '../firebase';
import BoardElement from '../board-element';
import wrapElement from '../element-wrapper';
import { screenToCanvasCoords } from '../util/canvas-util';
import { renderRoomTopMembersWidget } from '../react/board-elements/widgets/room-top-members/render-room-top-members-widget.tsx';
import {
  ROOM_TOP_MEMBERS_WIDGET_MIN_HEIGHT_PX,
  ROOM_TOP_MEMBERS_WIDGET_MIN_WIDTH_PX,
} from '../constants/board-constants';
import { track } from '../util/analytics-util';
import { addSystemMessage } from '../message-util';
import {
  ADD_ELEMENT,
  ADD_ELEMENT_DESTINATION_TYPES,
  ELEMENT_TYPES,
} from '../constants/analytics-events/element-events';

export default class RoomTopMembersWidget extends BoardElement {
  elementDescription() {
    return 'room-top-members-widget';
  }

  icon() {
    return 'clock';
  }

  minSize() {
    return [ROOM_TOP_MEMBERS_WIDGET_MIN_WIDTH_PX, ROOM_TOP_MEMBERS_WIDGET_MIN_HEIGHT_PX];
  }

  // Required method
  // Returns: True if update has been handled, false if it should be reloaded
  handleUpdate(__element, __elementDoc) {
    return true;
  }

  // Required method
  // Called after the html for the element has been laid out in the DOM
  setup(__elementId, __elementDoc) {}

  getElement(elementDoc) {
    const element = document.createElement('div');
    element.style.height = '100%';
    element.style.minHeight = `${ROOM_TOP_MEMBERS_WIDGET_MIN_HEIGHT_PX}px`;
    element.style.minWidth = `${ROOM_TOP_MEMBERS_WIDGET_MIN_WIDTH_PX}px`;
    renderRoomTopMembersWidget(element, this.elementId);
    return wrapElement(element, elementDoc, { preserveAspectRatio: true });
  }

  static async addElement() {
    const center = screenToCanvasCoords(
      Math.floor(Math.random() * 200 - 100) + window.innerWidth / 2,
      Math.floor(Math.random() * 200 - 100) + window.innerHeight / 2
    );

    await db.collection(`boards/${window.currentBoardId}/elements`).add({
      class: 'RoomTopMembersWidget',
      center,
      size: [ROOM_TOP_MEMBERS_WIDGET_MIN_WIDTH_PX, ROOM_TOP_MEMBERS_WIDGET_MIN_HEIGHT_PX],
      creator: firebase.auth().currentUser.uid,
      backgroundColor: '#ffffff',
      zIndex: window.getFrontZIndex(),
    });

    addSystemMessage('added a top members widget');
    track(ADD_ELEMENT, { element: ELEMENT_TYPES.TOP_MEMBERS, destination: ADD_ELEMENT_DESTINATION_TYPES.ROOM });
  }
}

RoomTopMembersWidget.elementType = 'RoomTopMembersWidget';
